module.exports = __webpack_public_path__ + "static/media/Meaningful-Business-2023.9bd98a5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Meaningful-Business-2023.jpg
// module id = 349
// module chunks = 0